import { parseServerDate } from "./datetime";

/** Legacy `services/map/event-status.ts` 승격 (F-11 KEEP). */
export type ComputedEventStatus = "SCHEDULED" | "ONGOING" | "ENDED" | "CANCELLED" | "UNKNOWN";

export interface EventWindow {
  startsAt?: string | null;
  endsAt?: string | null;
  status?: string | null;
}

/**
 * 서버는 타임존 없는 ISO 를 준다 (실측: `2026-09-10T15:04:08.589150`).
 * `Date.parse` 로 그냥 읽으면 **로컬 시각**으로 해석돼, 한국에서는 9시간 어긋난다 —
 * 이벤트가 아홉 시간 일찍 끝난 것으로 보이고 D-day 도 하루씩 틀어진다.
 * 날짜 해석은 한 곳(`parseServerDate`)에서만 한다.
 */
function parse(v?: string | null): number | null {
  return parseServerDate(v)?.getTime() ?? null;
}

/**
 * I-EV-03: 종료된 이벤트를 삭제하지 않는다. 상태로만 표현한다.
 * 서버가 CANCELLED 를 주면 시간과 무관하게 그대로 존중한다.
 */
export function eventStatus(e: EventWindow, now: Date = new Date()): ComputedEventStatus {
  if (e.status === "CANCELLED") return "CANCELLED";
  const s = parse(e.startsAt);
  const en = parse(e.endsAt);
  if (s === null || en === null) return "UNKNOWN";
  const t = now.getTime();
  if (t < s) return "SCHEDULED";
  if (t > en) return "ENDED";
  return "ONGOING";
}

/** 마감 임박 판정. StickerBadge("D-3") 노출 기준. */
export function daysUntilEnd(e: EventWindow, now: Date = new Date()): number | null {
  const en = parse(e.endsAt);
  if (en === null) return null;
  return Math.ceil((en - now.getTime()) / 86_400_000);
}
export function isEndingSoon(e: EventWindow, withinDays = 7, now: Date = new Date()): boolean {
  if (eventStatus(e, now) !== "ONGOING") return false;
  const d = daysUntilEnd(e, now);
  return d !== null && d >= 0 && d <= withinDays;
}
